import { arrayToObj } from "@/lib/utilities/index";
export const StringStartRegex = /^/;
export const StringEndRegex = /$/;
export const CountryCodes = {
  USA: 1,
  Canada: 2
};

export var NotificationType = {
  MessageResponse: 1, //supported
  Article: 2,
  Gaming: 3,
  Gaming_leaderChange: 4,
  PendingUser: 5,
  ApprovedUser: 6,
  DeviceTokenCheck: 9,
  WorkflowMessageActionStatus: 10,
  GroupResponse: 11, //supported
  GroupCreatedResponse: 12, //supported
  GroupUpdatedResponse: 13, //supported
  GroupDeletedResponse: 14, //supported
  GroupAddUserResponse: 15, //supported
  GroupRemoveUserResponse: 16, //supported
  GroupFavoriteResponse: 17, //supported
  SystemResponse: 18,
  AccountUserResponse: 19, //supported
  UserResponse: 20, //supported
  SystemWideResponse: 21,
  SystemWideUnavailable: 22,
  SystemWideLogout: 23,
  UserNotification: 24, //supported
  StoreNotification: 25,
  GroupMessageResponse: 26, //supported
  ViewStoreUpdate: 27, //supported
  FavoriteUserResponse: 29, //supported
  CalendarEvent: 34,
  CalendarEventStatus: 35,
  CalendarEventReminder: 36,
  UserGroupInfoMessage: 111,
  GroupCreatedMessage: 112,
  GroupUpdatedMessage: 113,
  GroupDeletedMessage: 114,
  GroupAddUserMessage: 115,
  GroupRemoveUserMessage: 116,
  GroupFavoriteMessage: 117,
  AccountUserInfoMessage: 119,
  UserInfoMessage: 120,
  GroupMessageMessage: 126,
  UserFavoriteMessage: 129,
  GroupSettingMessage: 133
};

export var ChannelType = {
  Unknown: 0,
  Control: 5,
  Direct: 10,
  Group: 20,
  Request: 30
};

export var StepInstanceStatus = {
  NotSet: 0,
  New: 10,
  Ready: 50,
  InProgress: 100,
  Overdue: 150,
  Paused: 500,
  Cancelled: 900,
  Success: 1000,
  CanClaimStep: 246,
  CanCompleteStep: 246
};

export var GroupType = {
  Unknown: 0,
  SystemAccount: 1, //Channels (Groups)
  SystemStore: 2, //Channels (Groups)
  AdHoc: 3, //Channels (Groups)
  Department: 4, //Channels (Groups)
  DirectMessage: 5, //Messages
  CrmCustomer: 6, //Channels (Groups)
  Request: 7, //Processes
  CustomAccount: 8, //Channels (Groups)
  CustomStore: 9, //Channels (Groups)
  Subscriptions: 11,
  CalendarEvent: 12,
  LeadClaim: 13,
  LeadGroup: 14,
  CustomerServiceSMS: 15,
  CustomerSalesSMS: 16,
  CustomerEmail: 17,
  CustomerLead: 18,
  SkateAlert: 19,
  WorkflowTaskNotification: 20,
  PAL: 21
};

export var GroupMessagingType = {
  None: 0,
  Broadcast: 10,
  Interactive: 20
};

export var MessageType = {
  Unknown: 0,
  User: 10,
  System: 20
};

export var WorkflowStepAction = {
  NotSet: 0,
  DeclineRequest: 5,
  Claim: 10,
  Complete: 20,
  TakeSurvey: 30,
  TakeForm: 40,
  CompleteYes: 50,
  CompleteNo: 60,
  Assign: 70,
  Reassign: 80
};
export var WorkflowStepType = {
  NotSet: 0,
  Task: 10,
  Form: 20,
  Survey: 30,
  File: 40,
  Condition: 50,
  Integration: 60
};
export var PayloadType = {
  Error: 999999,
  NotSet: 0,
  Url: 1,
  Inventory: 2,
  Customer: 3,
  AutoAlertNotification: 4,
  Giphy: 5,
  Form: 6,
  Json: 7,
  AddUser: 8,
  RemoveUser: 9,
  Image: 10,
  File: 11,
  MarkDown: 12
};
export var CoreUserStatus = {
  Active: 1,
  Inactive: 2,
  Pending: 3
};
export var UserAvailability = {
  Available: 10,
  Busy: 20,
  // "Not Available": 100,
  NotAvailable: 100
};
export var DataMiningAlertBlock = {
  NONE: 0x00000000,
  A: 0x00000001, // Alert
  F: 0x00000002, // Flex Alert
  S: 0x00000004, // Service Alert
  P: 0x00000008, // Service Appointment
  M: 0x00000010, // Mileage Alert
  W: 0x00000020, // Warranty Alert
  C: 0x00000040, // Contract End Alert
  I: 0x00000080, // In-Market Alert
  E: 0x00000100 // In-Market Engaged Alert
};

export var InboxFilterCategory = {
  Inbox: "Inbox",
  UnreadMessages: "Inbox: Unread Messages",
  New: "Inbox: New",
  InProgress: "Inbox: In Progress",
  Overdue: "Inbox: Overdue",
  Favorites: "Favorites",
  Messages: "Messages",
  //Channels: 'Channels', // NOTE: changed to "Groups"
  Groups: "Groups",
  Processes: "Processes",
  Tasks: "Tasks"
};
// SupportedFileUploadFormats: ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "tif", "csv", "pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt", "rtf"],
export var SupportedFilePreviewFormats = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "svg",
  "jfif",
  "txt"
];
export var SupportedVideoFormats = ["mp4", "mov", "ogg", "webm", "ogv"];
export var SupportedAudioFormats = ["mp3", "wav"];
export var FileFormatIcons = [
  "csv",
  "doc",
  "docx",
  "eml",
  "form",
  "html",
  "pdf",
  "ppt",
  "pptx",
  "rtf",
  "tif",
  "tiff",
  "txt",
  "xls",
  "xlsx"
];
export var Colors = [
  "304976",
  "6CBE6A",
  "68A4D6",
  "68CCE4",
  "95989A",
  "9088BF",
  "E94D68",
  "EE8761",
  "F8BE6B"
];
export var DefaultAvatars = {
  PandoBot: "static/assets/img/pando_bot_avatar.png",
  Channel: "static/assets/img/channel_avatar.png"
};
export var WorkflowInstanceStatus = {
  NotSet: 0,
  New: 10,
  InProgress: 100,
  Overdue: 150,
  Cancelled: 900,
  AutoCancelled: 901,
  Success: 1000
  // CanClaim: New | InProgress | Overdue,
  // CanComplete: InProgress | Overdue
};
export var FormInputTypes = [
  {
    Name: "SectionHeader",
    Id: 0
  },
  {
    Name: "Boolean",
    Id: 1
  },
  {
    Name: "ShortAnswer",
    Id: 2
  },
  {
    Name: "LongAnswer",
    Id: 3
  },
  {
    Name: "SingleSelectDropDown",
    Id: 4
  },
  {
    Name: "MultiSelection",
    Id: 5
  },
  {
    Name: "Date",
    Id: 6
  },
  {
    Name: "Time",
    Id: 7
  },
  {
    Name: "SingleSelectRadio",
    Id: 8
  },
  {
    Name: "LinearScale",
    Id: 9
  },
  {
    Name: "ShortName",
    Id: 10
  },
  {
    Name: "FullName",
    Id: 11
  },
  {
    Name: "Address",
    Id: 12
  }
];
export var HtmlEscapeCodes = [
  {
    Symbol: /&/g,
    EscapeCode: "&amp ,"
  },
  {
    Symbol: /"/g,
    EscapeCode: "&quot ,"
  },
  {
    Symbol: /'/g,
    EscapeCode: "&#039 ,"
  },
  {
    Symbol: /</g,
    EscapeCode: "&lt ,"
  },
  {
    Symbol: />/g,
    EscapeCode: "&gt ,"
  }
];

export const Days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

export var KeyCodes = {
  Enter: 13,
  UpArrow: 38,
  DownArrow: 40
};
export var Mentions = {
  NotSet: 0,
  User: 1,
  Channel: 2,
  Reserved: 3
};
export var NotifyLevel = {
  All: 1,
  MentionsOnly: 2,
  None: 3
};
export var UserWorkScheduleType = {
  NotScheduled: 1,
  Scheduled: 10,
  TimeOff: 20,
  Sick: 30,
  Training: 40,
  Other: 100
};

export var Package = {
  AlertMinerOnly: 2,
  Bronze: 3,
  Pilot: 4
};

export var ProductStatus = {
  NotSet: 0,
  Setup: 1,
  Live: 2,
  Cancelled: 3,
  OnHold: 4
};

export var Product = {
  ContentFuzeFULL: 1,
  ConnectPro: 2,
  ShowroomPro: 3,
  ComparePro: 4,
  ServicePro: 5,
  SpanishContentFuze: 6,
  VDPTool: 7,
  AutoWebSupport: 9,
  ReputationPro: 10,
  CuratorPro: 11,
  CuratorProPlus: 12,
  ReviewBuilderPro: 13,
  WebsiteContentPage: 14,
  FuzeCast: 15,
  ManagedServices: 16,
  ProfileFuze: 17,
  AlertMiner: 18,
  OneToOne: 19,
  Pando: 20,
  AutoAssistant: 23,
  PAL: 27
};

export let AccountProductFeature = {
  ExperienceManager: 16384,
  CXM: 262144,
  SLM: 1572864,
  PandoMessages: 4718592,
  ILM: 5767168,
  AutoAssistantSales: 2097152,
  AutoAssistantService: 33554432,
  AutoAssistantLeads: 34078720,
  ReputationPro: 6291456,
  SurveyPro: 34603008,
  VideoMessaging: 35127296,
  PAL: 36175872
};

export var FeatureFlags = {
  Calendar: 1, //fuzecast
  Reviews: 2, //fuzecast
  Comparisons: 4, //fuzecast
  Articles: 8, //fuzecast
  Messages: 16, //fuzecast
  Pando: 32, //fuzecast
  ProfileFuze: 64, //fuzecast
  Gamification: 128, //fuzecast
  Reports: 256, //fuzecast
  PandoLite: 512, //fuzecast
  Full: 1024, //alertminer
  ServiceLaneTechnology: 2048, //alertminer  aka ServiceDriveOffers
  OnlineOffer: 4096, //OneToOne Online Activation
  ExperienceManager: 16384,
  CXM: 262144,
  AutoAssistantSales: 2097152,
  AutoAssistantService: 33554432,
  AutoAssistantLeads: 34078720,
  Processes: 5242880,
  Subscriptions: 4194304,
  ILM: 5767168,
  CallTracking: 8388608,
  Survey: 34603008,
  VideoMessaging: 35127296,
  PAL: 36175872
};

export let ProductFeatureAvailability = {
  Unknown: 0,
  Required: 1,
  Optional: 2,
  Disabled: 3
};

export const DisabledProducts = {
  CuratorPro: 11,
  ProfileFuze: 17
};

export const DisabledFeatures = {
  Articles: 8,
  Comparisons: 4,
  Gamification: 128,
  Messages: 16,
  Pando: 32,
  PandoLite: 512,
  ProfileFuze: 64,
  Reports: 256,
  Reviews: 2,
  HR: 8192,
  Tagging: 32768,
  ServiceLaneTechnology: 2048,
  OnlineOffer: 4096
};

export let LinkedProductFeatures = {
  AlertMiner_SLM_Pando_Messages: 1,
  AutoAssistant_Leads_Pando_ILM: 2,
  AutoAssistant_Service_Pando_CXM: 3,
  ReputationPro_SurveyPro_ReputationPro: 4,
  Pando_VideoMessaging_PAL_PAL: 5
};

export let PacketStatus = {
  Draft: 0,
  Active: 1,
  Archive: 2
};

export let FormStatus = {
  Draft: 0,
  Active: 1,
  Archive: 2
};

export var ConfigurationCategory = {
  GeneralSettings: 0,
  Publishing: 1,
  Curator: 2,
  Connect: 3,
  Reputation: 4,
  DealerSetup: 5,
  AWSSetting: 6,
  GoogleAnalytics: 7,
  VendorSettings: 8,
  EmailTemplates: 9,
  RecallDataLoad: 10,
  Translation: 11,
  Twilio: 12
};

export var ConfigurationDataType = {
  String: 1,
  Int: 2,
  DateTime: 3,
  Double: 4
};

export const Permissions = {
  NotSet: 0,
  Developer_Admin: 1,
  System_Product_Edit: 2,
  System_Product_View: 3,
  System_DealerDomain_Blacklist: 4,
  System_DealerDomain_Edit: 5,
  System_UserList_Edit: 6,
  System_UserList_View: 7,
  O2O_Activation_Edit: 8,
  Add_People_To_Group: 9,
  System_WebsiteVendor_View: 10,
  UserSetupVerification: 11,
  Manage_Showroom_Activity_Settings: 12,
  Manage_LeadSettings: 13,
  ManageTemplates: 14,
  RulesAdministration: 15,
  RulesViewOnly: 16,
  WorkscheduleAdmin: 35,
  Manage_Roles: 36,
  Manage_Alertminer_Roles: 37,
  Change_Status: 38,
  Manage_Packages: 39,
  Manage_Forms: 40,
  ManageCallTracking: 41,
  SisenseDashboardManager: 150,
  TableauViewManager: 317,
  Dmspush_Admin: 151,
  View_AlertMiner_Settings: 467,
  Manage_Assignments: 1437,
  Crm_Import: 1404,
  Manage_Integration_Settings: 1635,
  Manage_Video_Library: 1648,
  Manage_System_Touchpoints: 1649,
  Orchestration_Engine: 1650
};

export const PermissionCodes = {
  [Permissions.Developer_Admin]: "developer.admin",
  [Permissions.Manage_Roles]: "system.roles.manage",
  [Permissions.Manage_Alertminer_Roles]: "system.roles.managealertminerroles",
  [Permissions.Manage_Packages]: "system.product.managepackages",
  [Permissions.System_Product_Edit]: "system.product.edit",
  [Permissions.System_Product_View]: "system.product.view",
  [Permissions.System_DealerDomain_Blacklist]: "system.dealerdomain.blacklist",
  [Permissions.System_DealerDomain_Edit]: "system.dealerdomain.edit",
  [Permissions.System_UserList_Edit]: "system.userlist.edit",
  [Permissions.System_UserList_View]: "system.userlist.view",
  [Permissions.O2O_Activation_Edit]: "o2o.activation.edit",
  [Permissions.Add_People_To_Group]: "system.groups.edit",
  [Permissions.System_WebsiteVendor_View]: "system.websitevendor.view ",
  [Permissions.UserSetupVerification]: "system.usersetupverification",
  [Permissions.Manage_Showroom_Activity_Settings]: "pando.cxm.showroomsettings",
  [Permissions.Manage_LeadSettings]: "pando.cxm.manageleadsettings",
  [Permissions.ManageTemplates]: "pando.cxm.managetemplates",
  [Permissions.RulesAdministration]: "pando.cxm.rules.admin",
  [Permissions.RulesViewOnly]: "pando.cxm.rules.viewonly",
  [Permissions.WorkscheduleAdmin]: "pando.workschedule.admin",
  [Permissions.Change_Status]: "system.userlist.changestatus",
  [Permissions.Manage_Forms]: "pando.cxm.forms.manage",
  [Permissions.SisenseDashboardManager]:
    "pando.analytics.sisensedashboardmanager",
  [Permissions.TableauViewManager]: "pando.analytics.tableauviewmanager",
  [Permissions.ManageCallTracking]: "pando.clicktocall.manage",
  [Permissions.Dmspush_Admin]: "pando.cxm.dmspush.admin",
  [Permissions.View_AlertMiner_Settings]: "pando.alertminer.settings.manage",
  [Permissions.Manage_Assignments]: "pando.cxm.assignments.manage",
  [Permissions.Crm_Import]: "pando.cxm.crmimport",
  [Permissions.Manage_Integration_Settings]: "pando.cxm.manageintegrations",
  [Permissions.Manage_Video_Library]: "pando.cxp.video",
  [Permissions.Manage_System_Touchpoints]: "system.touchpoints.manage",
  [Permissions.Orchestration_Engine]: "system.orchestration.engine"
};

export let RightNavMode = {
  NotSet: 0,
  Normal: 1, // Pushes the panels left for display
  Overlay: 2, // Displays on top of the panels with a fixed width (500px)
  ExtendedOverlay: 3, // Displays on top of the panels with a variable width (65%)
  PanelOverlay: 4, // Displays on top of the second panel
  FullOverlay: 5 // Displays on top of the panel container
};

export let RightNavContentType = {
  NotSet: 0,
  LeadSource: 1,
  EditVideo: 2
};

export let RulesEngineTaskType = {
  LeadAssignment: 10,
  SendToAutoAssistant: 13
};

export var EpochTicks = 621355968000000000;

export var AccountPlatformDomainBlacklistStatus = [
  {
    Id: 1,
    Name: "Unassigned"
  },
  {
    Id: 2,
    Name: "Blacklist"
  },
  {
    Id: 3,
    Name: "Assigned"
  }
];

export var BlackListStatusEnum = {
  Unassigned: 1,
  Blacklist: 2,
  Assigned: 3
};

export var WebsiteType = {
  ContentFuze: "Z",
  MainSite: "M",
  FuzeCast: "F",
  StoreSite: "S",
  Competitor: "C",
  ThirdParty: "T",
  OemAssociation: "O",
  PortalSite: "P",
  WifiPortalSite: "W"
};

export var MemberRoleType = {
  Member: 1,
  Admin: 2
};

export var PublishStatus = {
  New: 1,
  Draft: 2,
  Scheduled: 3,
  Published: 4,
  Rejected: 5
};

export var SocialType = {
  Twitter: 1,
  Tumblr: 2,
  Facebook: 3,
  LinkedIn: 4,
  GooglePlus: 5,
  YouTube: 6,
  BlogWP: 7,
  Pinterest: 8,
  AutoAlert: 9
};

export var Category = {
  Reviews: 1,
  Videos: 2,
  Comparisons: 3,
  ConceptCars: 4,
  Incentives: 5,
  ServiceCenter: 6,
  Racing: 7,
  OEMEvents: 8,
  CommunityOutreach: 9,
  Safety: 10,
  Technology: 11,
  Recalls: 12,
  Other: 13,
  CustomerStories: 14,
  IndustryAwards: 15,
  LocalInterest: 16,
  FoodHome: 17,
  DealerReviews: 18,
  Website: 19,
  Inventory: 20,
  ServiceOffers: 21,
  NationalNews: 22,
  Business: 23,
  Fashion: 24,
  ComicsMemes: 25,
  Gaming: 26,
  Education: 27,
  Science: 28,
  Finance: 29,
  Sports: 30,
  Entertainment: 31,
  Travel: 32,
  NationalTrending: 33,
  ClassicsExotics: 34,
  WorldNews: 35,
  HealthWellness: 36,
  IndustryInfluencers: 37,
  AutomotiveGeneral: 38,
  AutomotiveMotorcycle: 39,
  Canadian: 40,
  DealerSources: 10000,
  LocalNews: 10001,
  LocalSports: 10002,
  SharePhoto: 10003
};

export var UserIntegrityReportProblems = {
  None: 0x00000000,
  SSO_User_Missing: 0x00000001,
  SSO_User_Disabled: 0x00000002, // Implies the user exists in SSO by UserName
  SSO_MissingClaim_MFESStaffId: 0x00000004, //
  SSO_MissingClaim_AAUserName: 0x00000008, //
  SSO_MissingClaim_MFUserName: 0x00000010, //
  SSO_MissingClaim_MFAccountId: 0x00000020, //
  SSO_MultipleClaim_MFESStaffId: 0x00000040, //
  SSO_MultipleClaim_AAUserName: 0x00000080, //
  SSO_MultipleClaim_MFUserName: 0x00000100, //
  SSO_MultipleClaim_MFAccountId: 0x00000200, //
  SSO_AlertMiner_AccountMisMatch: 0x00000400, //

  Pando_MissingByUserName: 0x00010000,
  Pando_SSO_UserIdClaimMisMatch: 0x00020000, // Implies the user exists in Pando by UserName
  Pando_SSO_AccountMisMatch: 0x00040000, //
  Pando_MissingSSOID: 0x00080000,
  Pando_UserDataMismatch: 0x00100000 // Data mismatch between AlertMiner and Pando for key data elements, will force a re-sync
};

export var ConfigurableProducts = {
  // ContentFuzeFULL: 1,
  // ConnectPro: 2,
  // ShowroomPro: 3,
  // ComparePro: 4,
  // ServicePro: 5,
  // SpanishContentFuze: 6,
  // VDPTool: 7,
  // AutoWebSupport: 9,
  ReputationPro: 10
  // CuratorPro: 11,
  // CuratorProPlus: 12,
  // ReviewBuilderPro: 13,
  // WebsiteContentPage: 14,
  // FuzeCast: 15,
  // ManagedServices: 16,
  // ProfileFuze: 17,
  // AlertMiner: 18,
  // OneToOne: 19,
  // Pando: 20
};

export var LeadSourceTermList = [
  {
    text: "No Term",
    value: 0
  },
  {
    text: "30 Days",
    value: 1
  },
  {
    text: "3 Months",
    value: 3
  },
  {
    text: "6 Months",
    value: 6
  },
  {
    text: "1 Year",
    value: 12
  },
  {
    text: "2 Years",
    value: 24
  }
];

export const TouchpointsByName = {
  Showroom: {
    id: 1,
    name: "Showroom",
    slug: "showroom_visit",
    steps: [
      { name: "Demo" },
      { name: "Trade Appraisal" },
      { name: "Write Up" },
      { name: "Manager Turn Over" }
    ]
  },
  Delivery: {
    id: 2,
    name: "Delivery",
    slug: "delivery",
    steps: [
      { name: "Finance & Insurance" },
      { name: "Accessories Intro" },
      { name: "Service Intro" },
      { name: "Tech Intro" }
    ]
  },
  VirtualShowroom: {
    id: 4,
    name: "Virtual Showroom",
    slug: "virtualShowroom",
    steps: [
      { name: "Demo" },
      { name: "Trade Appraisal" },
      { name: "Write Up" },
      { name: "Manager Turn Over" }
    ]
  }
};

export const TouchpointsById = {
  [TouchpointsByName.Showroom.id]: TouchpointsByName.Showroom,
  [TouchpointsByName.Delivery.id]: TouchpointsByName.Delivery
};

export let RuleFilters = {
  LeadSource: 102,
  Stock: 106,
  VehicleOfInterest: 105,
  StockStartsWith: 138,
  StockEndsWith: 139
};

export let VehicleType = {
  New: 0,
  Used: 1,
  CPO: 2
};

export let LeadType = {
  InternetLeadTypeSales: 2
};

export let ActivityRulesRoleType = {
  SalesAssociate: 1,
  SalesAssociate2: 2,
  BDAgent: 3,
  SalesManager: 4,
  ServiceAdvisor: 5,
  FAndIManager: 6
};

export const AutoCloseNotificationRecipientObjects = [
  { key: 1, name: "User" },
  { key: 2, name: "Group" },
  { key: 3, name: "Role" }
];

export const AutoCloseDurationUnits = [
  { key: 2, name: "Hours" },
  { key: 3, name: "Days" }
];

export const SisenseDefaultCategory = {
  id: 0,
  name: "N/A",
  color: "bg-potato"
};

export const SisenseCategoryMapByName = {
  Other: SisenseDefaultCategory,
  CXMActivity: { id: 1, name: "CXM Activity", color: "bg-ocean" },
  LeadReporting: { id: 2, name: "Lead Reporting", color: "bg-avocado" },
  Revenue: { id: 3, name: "Revenue", color: "bg-ocean-deep" },
  Inventory: { id: 4, name: "Inventory", color: "bg-apple" },
  Campaign: { id: 5, name: "Campaign", color: "bg-pond" },
  PandoProcess: { id: 6, name: "Pando Process", color: "bg-sapota" },
  FixedOperations: { id: 7, name: "Fixed Operations", color: "bg-orange" }
};

export const SisenseCategoryMap = arrayToObj(
  Object.values(SisenseCategoryMapByName),
  "id"
);

export const SisenseCategories = Object.values(SisenseCategoryMap)
  .filter(e => e.name != SisenseDefaultCategory.name)
  .sort((a, b) =>
    // Sort default names LAST
    (!a.name || a.name == SisenseDefaultCategory.name
      ? "~~~~~"
      : a.name
    ).toLowerCase() >
    (!b.name || b.name == SisenseDefaultCategory.name
      ? "~~~~~"
      : b.name
    ).toLowerCase()
      ? 1
      : -1
  );

export const TableauDefaultCategory = {
  id: 0,
  name: "N/A",
  color: "bg-potato"
};

export const TableauCategoryMapByName = {
  Other: TableauDefaultCategory,
  CXMActivity: { id: 1, name: "CXM Activity", color: "bg-ocean" },
  LeadReporting: { id: 2, name: "Lead Reporting", color: "bg-avocado" },
  Revenue: { id: 3, name: "Revenue", color: "bg-ocean-deep" },
  Inventory: { id: 4, name: "Inventory", color: "bg-apple" },
  Campaign: { id: 5, name: "Campaign", color: "bg-pond" },
  PandoProcess: { id: 6, name: "Pando Process", color: "bg-sapota" },
  FixedOperations: { id: 7, name: "Fixed Operations", color: "bg-orange" }
};

export const TableauCategoryMap = arrayToObj(
  Object.values(TableauCategoryMapByName),
  "id"
);

export const TableauCategories = Object.values(TableauCategoryMap)
  .filter(e => e.name != TableauDefaultCategory.name)
  .sort((a, b) =>
    // Sort default names LAST
    (!a.name || a.name == TableauDefaultCategory.name
      ? "~~~~~"
      : a.name
    ).toLowerCase() >
    (!b.name || b.name == TableauDefaultCategory.name
      ? "~~~~~"
      : b.name
    ).toLowerCase()
      ? 1
      : -1
  );

export const ModalTypes = {
  Confirmation: "Confirmation",
  Scheduler_CopySchedule: "Scheduler_CopySchedule",
  Scheduler_EditSchedule: "Scheduler_EditSchedule",
  Scheduler_EditDefaultSchedule: "Scheduler_EditDefaultSchedule",
  EditSisenseDashboard: "EditSisenseDashboard",
  ChangeOwnershipSisenseDashboard: "ChangeOwnershipSisenseDashboard",
  SharedWithListSisenseDashboard: "SharedWithListSisenseDashboard",
  MigrateFavoritesSisenseDashboard: "MigrateFavoritesSisenseDashboard",
  EditTableauView: "EditTableauView",
  MigrateFavoritesTableauView: "MigrateFavoritesTableauView"
};

// https://stackoverflow.com/a/5717133
export const URLRegex = new RegExp(
  "^(https?:\\/\\/)?" + // protocol
  "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
  "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
  "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
  "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    "(\\#[-a-z\\d_]*)?$", // fragment locator
  "i"
);

export const Events = {
  Scheduler_ReloadData: "Scheduler_ReloadData",
  Scheduler_ReloadOrgTeams: "Scheduler_ReloadOrgTeams",
  RefreshSisenseDashboardList: "RefreshSisenseDashboardList",
  RefreshTableauViews: "RefreshTableauViews"
};

export const defaultRuleRank = 9999;

export const TaskStatus = {
  Pending: 1,
  InProgress: 2,
  Overdue: 3,
  Completed: 4,
  Cancelled: 5
};
export const ScheduleTypes = {
  Unscheduled: 1,
  Scheduled: 10,
  TimeOff: 20,
  Sick: 30
};

export const RenderedScheduleTypes = [
  ScheduleTypes.Scheduled,
  ScheduleTypes.TimeOff,
  ScheduleTypes.Sick
];

export const RoleSystemNames = {
  SalesPerson: "dealer.sales.sales_person",
  SalesManager: "dealer.sales.sales_manager",
  BDCAgent: "dealer.sales.bdc_agent",
  BDCManager: "dealer.sales.bdc_manager",
  ServiceAdvisor: "dealer.service.service_advisor",
  ServiceManager: "dealer.service.service_manager",
  FIManager: "dealer.sales.f_and_i_manager",
  DealerAdmin: "dealer.office.dealer_admin",
  GeneralManager: "dealer.office.general_manager",
  UsedCarManager: "dealer.sales.used_car_sales_manager",
  MarketingManager: "dealer.office.marketing_manager",
  GeneralSalesManager: "dealer.sales.general_sales_manager",
  PartsManager: "dealer.parts.parts_manager"
};

export const AssignmentRoleGroupsSystemNames = {
  sales: [
    RoleSystemNames.SalesPerson,
    RoleSystemNames.SalesManager,
    RoleSystemNames.BDCAgent,
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ],
  salesManager: [
    RoleSystemNames.SalesManager,
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ],
  serviceAdvisor: [
    RoleSystemNames.ServiceAdvisor,
    RoleSystemNames.ServiceManager,
    RoleSystemNames.PartsManager
  ],
  bdcAgent: [
    RoleSystemNames.BDCAgent,
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ],
  bdcOnly: [RoleSystemNames.BDCAgent, RoleSystemNames.BDCManager],
  fiManager: [
    RoleSystemNames.BDCManager,
    RoleSystemNames.DealerAdmin,
    RoleSystemNames.FIManager,
    RoleSystemNames.GeneralSalesManager,
    RoleSystemNames.UsedCarManager,
    RoleSystemNames.MarketingManager
  ]
};

export const EventBusEvents = {
  ReloadPackageDetails: "ReloadPackageDetails",
  RefreshVideos: "RefreshVideos",
  CollapsePayloadEditor: "CollapsePayloadEditor"
};

export let LoadingStatus = {
  Loading: 1,
  Loaded: 2
};

export let DayOfTheWeek = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6
};

export const PhoneType = {
  Unknown: 0,
  HomePhone: 1,
  WorkPhone: 2,
  CellPhone: 3
};

export let LeadCategory = {
  Sales: 1,
  Service: 2,
  Parts: 3
};

export let PageSize = {
  US_Letter: "us_letter",
  US_Legal: "us_legal"
};

export let PageSizeDimensions = {
  [PageSize.US_Letter]: {
    Width: "8.5in",
    Height: "11in"
  },
  [PageSize.US_Legal]: {
    Width: "8.5in",
    Height: "14in"
  }
};

export let FormStatusList = [
  {
    id: 0,
    name: "Inactive"
  },
  {
    id: 1,
    name: "Active"
  },
  {
    id: 2,
    name: "Deleted"
  }
];

export let TokenCategory = {
  Constants: 34
};

export const FormTokens = {
  EmptyToken: 209,
  DriversLicenseNumber: 214,
  DriversLicenseIssue: 215,
  DriversLicenseExpiration: 216,
  CheckboxToken: 220,
  RadioButtonToken: 221,
  DriversLicenseFront: 222,
  DriversLicenseBack: 223
};

export const FormType = {
  NotSet: 0,
  CustomQuote: 1
};

export const CallTrackingProvider = {
  Unknown: 0,
  InteractiveTel: 1,
  CarWars: 2
};

export const TableauAppsList = [
  {
    Name: "AlertMiner",
    Id: 1
  },
  {
    Name: "Pro/CXM",
    Id: 2
  }
];

export const VideoTypes = [
  {
    Id: 1,
    Name: "Sales"
  },
  {
    Id: 2,
    Name: "Service"
  }
];

export const VideoAccessLevels = {
  Personal: 1,
  Dealer: 2,
  Both: 3
};

export const SkateAlertSearchType = {
  Standard: 1,
  Phone: 2,
  Email: 3,
  PhoneOrEmail: 4
};

export const VideoStatuses = {
  Processing: 1,
  Complete: 2,
  Failed: 3
}

export let DMSTypes = {
  NA: 0,
  CDK: 1,
  RCI: 2,
  Serti: 23,
  DealerTrack: 9,
  PBS: 16,
  Automate: 5,
  Dealerbuilt: 38,
  AutoVance: 39,
  CDK180: 18,
  Tekion: 40,
  AutoFi: 43,
  VinSolutions: 44
};

export let IntegrationTypes = {
  DealDetails: 0,
  CDK: 1,
  RCI: 2,
  Advent: 3,
  ACS: 4,
  Automate: 5,
  LightYear: 6,//(DealerBuilt)
  UCS: 8,
  DealerTrack: 9,
  AutoSoft: 10,
  InfinitiNet: 11,
  DealerPush: 12,
  MPKDMS: 13,//(Microsoft)
  Arkona: 14,
  DPC: 15,
  PBS: 16,
  CTWizard: 17,
  Adf: 18,
  ABC: 19,
  ADAM: 20,
  ProMax: 21,
  Quorum: 22,
  Serti: 23,
  DIS: 24,
  Zeus: 25,
  DominionDMX: 26,//(Microsoft)
  Grapevine: 27,
  Procede: 29,
  Oasis: 30,
  Skywerks: 31,
  Deskit: 32,
  DealershipTracker: 33,
  IDS: 34,
  DASH: 35,
  PBSDDS: 36,
  EasyDeal: 37, Dealerbuilt: 38,
  Autovance: 39,
  Tekion: 40,
  SevenHundredCredit: 41,
  SevenHundredPrescreen: 42,
  AutoFi: 43,
  VinSolutions: 44,
  RouteOne: 45,
  DealerTrackLeads: 46,
  CreditConvert: 47,
}

export let OrchestrationStageTypes = {
  ContactSync: 3,
  SalespersonRepair: 4,
  AMActivityImport: 5,
  WorkflowCleanup: 6,
  EmailTemplateCleanup: 7,
  DowngradeDealers: 8,
  EnterpriseLinking: 9,
  EnableUserEmailExternalNotifications: 10,
  EnableUserTextExternalNotifications: 11,
}



// WEBPACK FOOTER //
// ./src/lib/utilities/enums.js